import { compose as o } from "../../tailwind-buddy-interface.js";
import { labelStyles as e } from "../../mixins/typography.js";
const i = o({
  slots: {
    root: `
      hz-field

      flex
      flex-col
      gap-y-075
    `,
    container: `
      hz-field__container
      
      relative 
      flex
      gap-050
      items-center
    `,
    slot: `
      z-[1] 
      shrink-0
    `,
    content: `
      hz-field__content

      grow

      grid 
      *:col-span-full
      *:row-span-full
      
      before:absolute 
      before:inset-x-0
      before:inset-y-0
      before:rounded-md
    `,
    control: `
      hz-field__control
    
      z-[1] 
      w-full
      
      
      appearance-none
      bg-color-static-transparent
      outline-none
    `,
    label: `
      hz-field__label
    
      z-[1]
      self-start
      justify-self-start
      max-w-full
      truncate
      pointer-events-none
      select-none
      ${e.lg}
    `,
    icon: `
      hz-field__icon
    
      z-[1] 
      shrink-0
      pointer-events-none
    `,
    supportText: `
      pe-050
      ps-050
    `
  },
  variants: {
    // Sets the field size.
    size: {
      xs: {
        root: "hz-field--size-xs",
        container: "ps-100 pe-100",
        content: "min-h-400 before:rounded-xs",
        control: `${e.md}`
      },
      sm: {
        root: "hz-field--size-sm",
        container: "ps-100 pe-100",
        content: "min-h-600 px-050",
        control: `${e.md}`
      },
      md: {
        root: "hz-field--size-md",
        container: "ps-150 pe-150",
        content: "min-h-700 px-050",
        control: `${e.lg}`
      }
    },
    // Sets the field type.
    type: {
      input: {
        root: ""
      },
      select: {
        root: "hz-field--select"
      },
      textarea: {
        root: "hz-field--textarea"
      }
    }
  },
  compoundVariants: [
    // isDisabled="false"
    {
      conditions: {
        isDisabled: !1
      },
      class: {
        container: "cursor-text",
        control: "cursor-text"
      }
    },
    // isDisabled="true"
    {
      conditions: {
        isDisabled: !0
      },
      class: {
        root: "hz-field--disabled",
        container: "cursor-not-allowed",
        control: `
          text-color-scheme-interactive-disabled-600
          cursor-not-allowed
        `,
        label: "text-color-scheme-interactive-disabled-400",
        icon: "text-color-scheme-interactive-disabled-200"
      }
    },
    // isDisabled="false" / isInvalid="false"
    {
      conditions: {
        isDisabled: !1,
        isInvalid: !1
      },
      class: {
        icon: "text-icon-color-primary",
        control: "text-color-primary",
        label: "text-color-secondary"
      }
    },
    // isDisabled="false" / isInvalid="true"
    {
      conditions: {
        isDisabled: !1,
        isInvalid: !0
      },
      class: {
        root: "hz-field--invalid",
        control: "text-color-scheme-functional-negative-800",
        label: "text-color-scheme-functional-negative-600",
        icon: "text-color-scheme-functional-negative-400"
      }
    },
    // disableAnimation="true"
    {
      conditions: {
        disableAnimation: !1
      },
      class: {
        content: "before:transition-[background-color,box-shadow]",
        label: `
          transition-all 
          ease-in-out
          duration-swift
        `,
        icon: "transition-[color]"
      }
    }
  ],
  defaultVariants: {
    size: "md",
    type: "input"
  },
  responsiveVariants: []
})();
export {
  i as fieldVariants
};
